import { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';

function OAuthXeroCallback({ route }: any) {
  const [tokenData, setTokenData] = useState(null);

  useEffect(() => {
    const urlHash = window.location.hash.substr(1);
    if (urlHash) {
      try {
        const data = JSON.parse(urlHash);
        if (data && data.tokens) {
          setTokenData(data.tokens);
        }
      } catch (error) {
        console.error('Error parsing URL fragment:', error);
      }
    }
  }, []);

  let params = useParams();

  return <></>;
}

export default OAuthXeroCallback;
